import { render, staticRenderFns } from "./Subcard.vue?vue&type=template&id=cffd0bac&"
import script from "./Subcard.vue?vue&type=script&lang=js&"
export * from "./Subcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports